module.exports = __webpack_public_path__ + "static/img/上一张.3985953.png";